module.exports = __webpack_public_path__ + "img/9.7f4e629e.png";